const pageNameKey = "blueprintStateInfoBannerRestructuringCounter";

export const blueprintStateInfoBannerRestructuringCounterEn = {
  [pageNameKey]: {
    folderIconAltText: "Folder Icon",
  },
};

export const blueprintStateInfoBannerRestructuringCounterPtBr = {
  [pageNameKey]: {
    folderIconAltText: "Ícone da pasta",
  },
};

export const blueprintStateInfoBannerRestructuringCounterDe = {
  [pageNameKey]: {
    folderIconAltText: "Verzeichnis-Icon",
  },
};

export const blueprintStateInfoBannerRestructuringCounterZhHans = {
  [pageNameKey]: {
    folderIconAltText: "文件夹图标",
  },
};

export const blueprintStateInfoBannerRestructuringCounterIt = {
  [pageNameKey]: {
    folderIconAltText: "Icona della cartella",
  },
};

export const blueprintStateInfoBannerRestructuringCounterEs = {
  [pageNameKey]: {
    folderIconAltText: "Icono de carpeta",
  },
};

export const blueprintStateInfoBannerRestructuringCounterNl = {
  [pageNameKey]: {
    folderIconAltText: "Map-pictogram",
  },
};

export const blueprintStateInfoBannerRestructuringCounterTr = {
  [pageNameKey]: {
    folderIconAltText: "Klasör Simgesi",
  },
};
